import { getCookieKey, CookieName } from "@utilities/cookieKeys";

const USER_COOKIE = getCookieKey(CookieName.User);

export const isSignedIn = () => document.cookie.includes(`${USER_COOKIE}=`);
